import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerforfivejyotilinga() {



const cardData =
{
  keyword: 'Tempo Traveller for 5 Jyotirlinga',
  heading: 'Sanavi Travels: Tempo Traveller for 5 Jyotirlinga Darshan',
  headingDescription: 'Sanavi Travels offers expertly planned and highly reliable Tempo Traveller for 5 Jyotirlinga Darshan, designed for devotees, families, senior citizens, religious groups, corporate spiritual tours, and pilgrimage mandals seeking a peaceful and well-organized sacred journey. The 5 Jyotirlinga Yatra is a spiritually significant pilgrimage covering revered Jyotirlinga temples located across different regions, often involving long-distance highway travel, ghat sections, rural roads, and multiple day schedules.',

  top: 'Sacred Pilgrimage Experiences with Tempo Traveller for 5 Jyotirlinga',

  "topPlaces": [
    {
      "title": "Trimbakeshwar Jyotirlinga",
      "description": "Trimbakeshwar, near Nashik, is one of the most revered Jyotirlingas of Lord Shiva. Traveling in a Tempo Traveller allows devotees to arrive together, stay relaxed during long road journeys, and focus entirely on darshan without travel fatigue or logistical stress."
    },
    {
      "title": "Bhimashankar Jyotirlinga",
      "description": "Located amidst dense forests and hilly terrain, Bhimashankar requires careful driving and proper time planning. A Tempo Traveller with an experienced driver ensures safe ghat travel, comfortable seating, and stress-free access to the temple."
    },
    {
      "title": "Grishneshwar Jyotirlinga",
      "description": "Grishneshwar, near Ellora, is often visited along with heritage sites. Tempo Traveller travel allows groups to manage darshan schedules smoothly while enjoying comfortable long-distance travel between destinations."
    },
    {
      "title": "Aundha Nagnath Jyotirlinga",
      "description": "Aundha Nagnath involves extended highway travel and rural connectivity. Group travel in a Tempo Traveller ensures unity, rest comfort, and safe arrival even during long driving hours."
    },
    {
      "title": "Parli Vaijnath Jyotirlinga",
      "description": "Parli Vaijnath is frequently included in multi-day Jyotirlinga circuits. Hiring a Tempo Traveller helps pilgrims maintain a relaxed pace, manage overnight halts, and travel comfortably between temples."
    },
    {
      "title": "Multi-Day Jyotirlinga Yatra",
      "description": "The 5 Jyotirlinga pilgrimage typically spans multiple days. Tempo Traveller hire ensures adequate rest, luggage convenience, and organized travel planning across all temple locations."
    },
    {
      "title": "Family Pilgrimage Travel",
      "description": "Families prefer Tempo Travellers for Jyotirlinga darshan due to safety, seating comfort, and the ability to travel together peacefully."
    },
    {
      "title": "Senior Citizen Friendly Travel",
      "description": "Pushback seating, smooth suspension, and professional driving make Tempo Travellers suitable for senior citizens undertaking long spiritual journeys."
    },
    {
      "title": "Group & Mandal Yatra",
      "description": "Religious groups and mandals benefit from Tempo Traveller travel by maintaining discipline, unity, and timely temple visits throughout the yatra."
    },
    {
      "title": "Peaceful & Devotional Journey",
      "description": "Traveling together in a single Tempo Traveller fosters devotion, calmness, and spiritual bonding among pilgrims."
    }
  ],

  "services": [
    {
      "name": "Tempo Traveller for 5 Jyotirlinga",
      "description": "Sanavi Travels provides dedicated Tempo Traveller services for complete 5 Jyotirlinga Darshan, ensuring safe, comfortable, and well-coordinated pilgrimage travel across multiple destinations."
    },
    {
      "name": "AC Tempo Traveller 5 Jyotirlinga",
      "description": "AC Tempo Travellers offer a cool and comfortable environment, ideal for long-distance and multi-day Jyotirlinga journeys."
    },
    {
      "name": "Non AC Tempo Traveller 5 Jyotirlinga",
      "description": "Non AC Tempo Travellers provide a budget-friendly option while maintaining safety, reliability, and seating comfort."
    },
    {
      "name": "12 Seater Tempo Traveller 5 Jyotirlinga",
      "description": "12 seater Tempo Travellers are ideal for small families and private devotional groups seeking flexibility and comfort."
    },
    {
      "name": "16 Seater Tempo Traveller 5 Jyotirlinga",
      "description": "16 seater Tempo Travellers suit medium-sized groups, balancing seating capacity with long-journey comfort."
    },
    {
      "name": "20 Seater Tempo Traveller 5 Jyotirlinga",
      "description": "20 seater Tempo Travellers are perfect for large groups, mandals, and community yatras traveling together."
    },
    {
      "name": "Luxury Tempo Traveller 5 Jyotirlinga",
      "description": "Luxury Tempo Travellers feature premium interiors and smooth rides, suitable for senior citizens and premium spiritual tours."
    },
    {
      "name": "Tempo Traveller with Driver 5 Jyotirlinga",
      "description": "All rentals include experienced drivers familiar with Jyotirlinga routes, highways, and temple access roads."
    },
    {
      "name": "Affordable Tempo Traveller 5 Jyotirlinga",
      "description": "We offer cost-effective Jyotirlinga travel packages without compromising safety or comfort."
    },
    {
      "name": "Group Tempo Traveller for Jyotirlinga",
      "description": "Group travel ensures everyone journeys together peacefully, improving coordination and spiritual focus."
    }
  ],

  "tableData": [
    ["5 Jyotirlinga Tempo Traveller", "AC Tempo Traveller"],
    ["Non AC Tempo Traveller", "Luxury Tempo Traveller"],
    ["12 Seater", "16 Seater"],
    ["20 Seater", "Group Pilgrimage"],
    ["Family Travel", "Multi-Day Yatra"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced Pilgrimage Drivers", "WhyChoosedescription": "Drivers familiar with all Jyotirlinga routes and long-distance travel." },
    { "WhyChooseheading": "Comfort for Long Journeys", "WhyChoosedescription": "Pushback seats and smooth suspension for extended travel hours." },
    { "WhyChooseheading": "Well-Planned Itineraries", "WhyChoosedescription": "Optimized routes covering all 5 Jyotirlingas efficiently." },
    { "WhyChooseheading": "Safe & Maintained Vehicles", "WhyChoosedescription": "Regular servicing, cleanliness, and safety checks." },
    { "WhyChooseheading": "Flexible Multi-Day Packages", "WhyChoosedescription": "Custom plans based on group size and duration." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear costs with no hidden charges." },
    { "WhyChooseheading": "Group-Friendly Travel", "WhyChoosedescription": "Entire group travels together peacefully." },
    { "WhyChooseheading": "Trusted Pilgrimage Partner", "WhyChoosedescription": "Sanavi Travels is known for reliable spiritual tour transport." }
  ]
};

const faqData = [
  { question: 'Do you provide Tempo Traveller for 5 Jyotirlinga Darshan?', answer: 'Yes, Sanavi Travels offers complete Tempo Traveller services for 5 Jyotirlinga Darshan.' },
  { question: 'Are AC Tempo Travellers available?', answer: 'Yes, both AC and Non AC Tempo Travellers are available.' },
  { question: 'Is the service suitable for senior citizens?', answer: 'Yes, our vehicles and drivers are suitable for senior citizen pilgrimage travel.' },
  { question: 'Can we plan a multi-day Jyotirlinga trip?', answer: 'Yes, multi-day customized packages are available.' },
  { question: 'Are drivers experienced with Jyotirlinga routes?', answer: 'Yes, our drivers are familiar with all Jyotirlinga temple routes.' },
  { question: 'What seating options are available?', answer: '12 seater, 16 seater, and 20 seater Tempo Travellers are available.' },
  { question: 'Are vehicles cleaned before departure?', answer: 'Yes, all Tempo Travellers are cleaned and safety-checked before trips.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, advance booking is advised due to long travel schedules.' },
  { question: 'Do you offer affordable packages?', answer: 'Yes, we provide budget-friendly pilgrimage travel packages.' },
  { question: 'Is pickup available from Pune?', answer: 'Yes, pickup is available from Pune and nearby locations.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Joshi',
    feedback: 'Our 5 Jyotirlinga yatra in a Tempo Traveller was very peaceful and well-planned. Excellent service by Sanavi Travels.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Anjali Deshmukh',
    feedback: 'Comfortable vehicle, experienced driver, and smooth coordination throughout the pilgrimage. Highly recommended.',
    rating: 5
  }
];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller for 5 Jyotirlinga - Sanavi Travels",
  "description": "Sanavi Travels offers Tempo Travellers for 5 Jyotirlinga tours, including family trips, corporate travel, group tours, weddings, and picnics. AC and Non-AC options are available in 12-seater, 16-seater, and 20-seater configurations with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};









  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Tempo Traveller for 5 Jyotirlinga | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Tempo Travellers for 5 Jyotirlinga tours with Sanavi Travels. AC & Non-AC 12, 16, and 20-seater Tempo Travellers for family trips, corporate travel, group tours, weddings, and picnics with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/283.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravellerforfivejyotilinga;